const normalizeCnpj = (value = '') => String(value).replace(/[^0-9A-Za-z]/g, '').toUpperCase()

const calculateCnpjDigit = (baseDigits, factors) => {
  const sum = baseDigits.reduce((acc, digit, index) => {
    return acc + (digit * factors[index])
  }, 0)

  const remainder = sum % 11
  const digit = remainder < 2 ? 0 : 11 - remainder

  return digit
}

const isValidNumericCnpj = (cnpjDigits) => {
  if (!/^\d{14}$/.test(cnpjDigits)) {
    return false
  }

  const digits = cnpjDigits.split('').map((digit) => Number(digit))

  if (digits.every((digit) => digit === digits[0])) {
    return false
  }

  const firstFactor = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const secondFactor = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  const firstBase = digits.slice(0, 12)
  const first = calculateCnpjDigit(firstBase, firstFactor)
  const secondBase = digits.slice(0, 12).concat(first)
  const second = calculateCnpjDigit(secondBase, secondFactor)

  return first === digits[12] && second === digits[13]
}

export const isValidCnpj = (value = '') => {
  const normalized = normalizeCnpj(value)

  if (/^[0-9A-Z]{14}$/.test(normalized)) {
    if (/^\d+$/.test(normalized)) {
      return isValidNumericCnpj(normalized)
    }

    return true
  }

  return false
}

export const normalizeCnpjInput = (value = '') => normalizeCnpj(value)

export const isValidCep = (value = '') => {
  const digits = String(value).replace(/\D/g, '')
  return digits.length === 8
}

export const normalizeCep = (value = '') => String(value).replace(/\D/g, '')
